import { Component } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Box, Button, CircularProgress, TextField, Typography, Chip, Autocomplete } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { Nutrition, WaterConsumption, Yes_Or_No } from '../../../../Utility/Constants';

export default class NutritionHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            yesorNoList: Yes_Or_No,
            nutritionList: Nutrition,
            waterConsumption: WaterConsumption,
            selectedNutritionYesOrNo: "",
            counsellingDescrip: "",
            selectedTypeNutrition: "",
            earlyDescrip: "",
            breakfastDescrip: "",
            midDescrip: "",
            lunchDescrip: "",
            eveningDescrip: "",
            dinnerDescrip: "",
            lateNightDescrip: "",
            selectedTypeNutritionValue: "",
            selectedWaterConsumption: null,
            nutritionHistoryEdit: false,
            nutritionLoading: false,
        };
    }
    componentDidMount() {
        let clinicId = getCachevalue('SelectedDoctorClinic')
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        this.setState({
            clinicId: clinicId,
            appointmentId: appointmentId?.appointment_id,
            patientId: appointmentId?.patient_id,
            patientDetails: appointmentId,
        }, () => {
            this.getPatientDetailData()
            this.getNutritionHistoryData()
        })
    }
    getPatientDetailData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientDetails: {...this.state.patientDetails, ...response?.data?.data}
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error.response.data.message || error.message)

                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getNutritionHistoryData = () => {
        try {
            this.setState({ nutritionLoading: true })
            RestAPIService.getAll(Serviceurls.DOC_NUTRITION_HISTORY + `?patient_id=${this.state.patientId}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({ nutritionLoading: false })
                        let data = response?.data?.data
                        if (Object.keys(data)?.length > 0) {
                            this.setState({
                                breakfastDescrip: data?.food_breakfast_amount,
                                dinnerDescrip: data?.food_dinner_amount,
                                earlyDescrip: data?.food_early_morning_amount,
                                eveningDescrip: data?.food_evening_amount,
                                lateNightDescrip: data?.food_late_night_amount,
                                lunchDescrip: data?.food_lunch_amount,
                                midDescrip: data?.food_mid_morning_amount,
                                nutritionFrozen: data?.is_frozen,
                                counsellingDescrip: data?.nutrition_counselling_date,
                                selectedNutritionYesOrNo: data?.nutritional_counselling === null ? '' : data?.nutritional_counselling ? 'Yes' : 'No',
                                selectedWaterConsumption: data?.water_consumption,
                                selectedTypeNutrition: (data?.nutrition_type).toString(),
                                nutritionHistoryEdit: true,
                                selectedTypeNutritionValue: (data?.nutrition_type).toString()
                            })
                        }
                    }
                }).catch(error => {
                    this.setState({ nutritionLoading: false })
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {
            this.setState({ nutritionLoading: false })
            this.errorMessage(error.message)
        }
    }

    postNutritionHistoryData = () => {
        try {
            let data = {
                food_breakfast_amount: this.state.breakfastDescrip,
                food_dinner_amount: this.state.dinnerDescrip,
                food_early_morning_amount: this.state.earlyDescrip,
                food_evening_amount: this.state.eveningDescrip,
                food_late_night_amount: this.state.lateNightDescrip,
                food_lunch_amount: this.state.lunchDescrip,
                food_mid_morning_amount: this.state.midDescrip,
                nutrition_counselling_date: this.state.counsellingDescrip,
                nutrition_type: this.state.selectedTypeNutritionValue,
                nutritional_counselling: this.state.selectedNutritionYesOrNo === '' ? null : this.state.selectedNutritionYesOrNo === 'Yes' ? true : false,
                patient_id: this.state.patientId,
                water_consumption: this.state.selectedWaterConsumption
            }
            this.setState({ nutritionLoading: true })
            RestAPIService.create(data, Serviceurls.DOC_NUTRITION_HISTORY)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({ nutritionLoading: false })
                        this.successMessage(response.data.message)
                        this.onClearNutritionData()
                        this.getNutritionHistoryData()
                    }
                }).catch(error => {
                    this.setState({ nutritionLoading: false })
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {
            this.setState({ nutritionLoading: false })
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    onClearNutritionData = () => {
        try {
            this.setState({
                breakfastDescrip: '',
                earlyDescrip: '',
                midDescrip: '',
                lunchDescrip: '',
                lateNightDescrip: '',
                eveningDescrip: '',
                dinnerDescrip: '',
                counsellingDescrip: '',
                selectedWaterConsumption: '',
                selectedNutritionYesOrNo: '',
                selectedTypeNutrition: '',
                selectedTypeNutritionValue: ''
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderTextBox = (names, value, label, width, disable, len) => {
        try {
            return (
                <TextField
                    size='small'
                    label={label}
                    InputProps={{ readOnly: disable }}
                    sx={{ width: width, mr: '0.5vw', mt: '0.5vw' }}
                    value={value}
                    inputProps={{ maxLength: len ? len : 250 }}
                    name={names}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (value?.length <= 250) {
                            this.setState({ [names]: value })
                        } else {
                            this.errorMessage('Allowed Only 250 Characters')
                        }
                    }}
                />
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    render() {
        const disable = this.state.nutritionHistoryEdit ? true : false
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                </Box>
                <Box id='nutrition' component={'div'} border={'1px solid lightgray'} my={'0.5vw'} height={'61.5vh'} overflow={'hidden'} sx={{ backgroundColor: Colors.white }}>
                    <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'2.5vw'} display={'flex'} justifyContent={'space-between'} pl={'0.5vw'} alignItems={'center'}>
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Nutrition'}</Typography>
                        {this.state.nutritionHistoryEdit ?
                            <Button className='Common_Btn_Min_Width'
                                onClick={() => this.setState({ nutritionHistoryEdit: false })}
                            >
                                <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.5vw'} width={'1.5vw'} />
                            </Button> :
                            <Box display={'flex'}>
                                <Button variant='contained'
                                    disabled={this.state.nutritionLoading || getCachevalue('DoctorUserChanged') === 'true'}
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => this.postNutritionHistoryData()}
                                >Add</Button>
                                <Button variant='outlined'
                                    sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                    onClick={() => this.onClearNutritionData()}
                                >Clear</Button>
                            </Box>
                        }
                    </Box>
                    {this.state.nutritionLoading ?
                        <Box component={'div'} ml={'0.5vw'} mt={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'20vw'}>
                            <CircularProgress color='primary' /></Box>
                        : <Box component={'div'} ml={'0.5vw'} mt={'0.5vw'}>
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} flexWrap={'wrap'}>
                                <Box width={'25vw'}>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Have you ever had Nutritional Counselling ?'}</Typography>
                                    <Box component={'div'}>
                                        {this.state.yesorNoList?.map((item, index) => {
                                            return (
                                                <Chip
                                                    className={`eMed_chip ${item.label === this.state.selectedNutritionYesOrNo ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                                    disabled={this.state.nutritionHistoryEdit}
                                                    label={item.label}
                                                    variant={item.label === this.state.selectedNutritionYesOrNo ? 'contained' : 'outlined'}
                                                    key={index}
                                                    onClick={() => {
                                                        if (item.label === this.state.selectedNutritionYesOrNo) {
                                                            this.setState({ selectedNutritionYesOrNo: '' })
                                                        } else {
                                                            this.setState({ selectedNutritionYesOrNo: item?.label })
                                                        }
                                                    }}
                                                    // color={'primary'}
                                                    clickable
                                                />
                                            )
                                        })}
                                        <Box component={'div'} mt={'0.5vw'}>
                                            {this.renderTextBox('counsellingDescrip', this.state.counsellingDescrip, 'Description', '25vw', disable)}
                                        </Box>
                                    </Box>
                                </Box>
                                <Box width={'25vw'}>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Types of Nutrition'}</Typography>
                                    <Box component={'div'}>
                                        {this.state.nutritionList?.map((item, index) => {
                                            return (
                                                <Chip
                                                    className={`eMed_chip ${item.value === this.state.selectedTypeNutrition ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                                    disabled={this.state.nutritionHistoryEdit}
                                                    label={item.label}
                                                    variant={item.value === this.state.selectedTypeNutrition ? 'contained' : 'outlined'}
                                                    key={index}
                                                    onClick={() => {
                                                        if (item.value === this.state.selectedTypeNutrition) {
                                                            this.setState({ selectedTypeNutrition: '', selectedTypeNutritionValue: '' })
                                                        } else {
                                                            this.setState({ selectedTypeNutrition: item?.value, selectedTypeNutritionValue: item?.value })
                                                        }
                                                    }}
                                                    // color={'primary'}
                                                    clickable
                                                />
                                            )
                                        })}
                                    </Box>
                                </Box>
                                <Box width={'25vw'}></Box>
                            </Box>
                            <Box component={'div'} mt={'0.5vw'} mb={'0.5vw'}>
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Please List the typical foods and amounts that you eat and drink on a typical day'}</Typography>
                            </Box>
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} flexWrap={'wrap'}>
                                <Box>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Early Morning'}</Typography>
                                    {this.renderTextBox('earlyDescrip', this.state.earlyDescrip, 'Description', '25vw', disable, 100)}
                                </Box>
                                <Box>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Breakfast '}</Typography>
                                    {this.renderTextBox('breakfastDescrip', this.state.breakfastDescrip, 'Description', '25vw', disable, 100)}
                                </Box>
                                <Box>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Mid-Morning'}</Typography>
                                    {this.renderTextBox('midDescrip', this.state.midDescrip, 'Description', '25vw', disable, 100)}
                                </Box>
                            </Box>
                            <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} flexWrap={'wrap'}>
                                <Box>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Lunch'}</Typography>
                                    {this.renderTextBox('lunchDescrip', this.state.lunchDescrip, 'Description', '25vw', disable, 100)}
                                </Box>
                                <Box>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Evening'}</Typography>
                                    {this.renderTextBox('eveningDescrip', this.state.eveningDescrip, 'Description', '25vw', disable, 100)}
                                </Box>
                                <Box>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Dinner'}</Typography>
                                    {this.renderTextBox('dinnerDescrip', this.state.dinnerDescrip, 'Description', '25vw', disable, 100)}
                                </Box>
                            </Box>
                            <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} flexWrap={'wrap'} mb={'1vw'}>
                                <Box>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Late Night'}</Typography>
                                    {this.renderTextBox('lateNightDescrip', this.state.lateNightDescrip, 'Description', '25vw', disable, 100)}
                                </Box>
                                <Box>
                                    <Typography fontSize={'0.9vw'} mr={'0.5vw'} fontWeight={600} color={Colors.SecondaryText}>{'Water Consumption(In Liters)'}</Typography>
                                    <Autocomplete
                                        clearIcon
                                        size='small'
                                        freeSolo
                                        sx={{ width: '25vw', mr: '0.5vw', mt: '0.5vw' }}
                                        options={this.state.waterConsumption.map((item) => item.label)}
                                        value={this.state.selectedWaterConsumption}
                                        limitTags={3}
                                        autoComplete='off'
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                selectedWaterConsumption: newValue
                                            })
                                        }}
                                        readOnly={this.state.nutritionHistoryEdit}
                                        onInputChange={(event, newValue) => {
                                            this.setState({ selectedWaterConsumption: newValue })
                                        }}
                                        renderInput={(params) => <TextField {...params} label='Select Water Consumption' />}
                                    />
                                </Box>
                                <Box width={'25vw'}></Box>
                            </Box>
                        </Box>
                    }
                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}